(function () {
  function initBar(bar) {
    var hours = parseInt(bar.getAttribute('data-hours'), 10) || 0;
    var minutes = parseInt(bar.getAttribute('data-minutes'), 10) || 0;
    var durationMs = (hours * 3600 + minutes * 60) * 1000;
    var storageKey = bar.getAttribute('data-storage-key');

    var hoursEl = bar.querySelector('[data-mt-hours]');
    var minutesEl = bar.querySelector('[data-mt-minutes]');
    var secondsEl = bar.querySelector('[data-mt-seconds]');

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function getDeadline() {
      var stored = null;
      try {
        stored = window.localStorage.getItem(storageKey);
      } catch (e) {
        stored = null;
      }
      var deadline = stored ? parseInt(stored, 10) : NaN;
      if (!deadline || isNaN(deadline) || deadline <= Date.now()) {
        deadline = Date.now() + durationMs;
        try {
          window.localStorage.setItem(storageKey, String(deadline));
        } catch (e) {
          /* localStorage unavailable, timer still works for this page view */
        }
      }
      return deadline;
    }

    var deadline = getDeadline();

    function render() {
      var remaining = deadline - Date.now();
      if (remaining <= 0) {
        deadline = Date.now() + durationMs;
        try {
          window.localStorage.setItem(storageKey, String(deadline));
        } catch (e) {}
        remaining = deadline - Date.now();
      }
      var totalSeconds = Math.floor(remaining / 1000);
      var h = Math.floor(totalSeconds / 3600);
      var m = Math.floor((totalSeconds % 3600) / 60);
      var s = totalSeconds % 60;
      if (hoursEl) hoursEl.textContent = pad(h);
      if (minutesEl) minutesEl.textContent = pad(m);
      if (secondsEl) secondsEl.textContent = pad(s);
    }

    render();
    setInterval(render, 1000);
  }

  function init() {
    document.querySelectorAll('[data-mt-countdown-bar]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
